import { defineMessages } from 'react-intl';

import generalMessages from 'src/messages';

const messages = defineMessages({
  expectedShipment: {
    id: 'expectedShipment',
    defaultMessage: 'Expected shipment:'
  },
  businessDays: {
    id: 'businessDays',
    defaultMessage: '{days} business days'
  },
  inquireShippingDays: {
    id: 'inquireShippingDays',
    defaultMessage: 'Please inquire for expected ship date.'
  },
  qualityTestingFull: {
    id: 'qualityTestingFull',
    defaultMessage: `Selecting 100% QC will add a minimum of 1 day to your shipping date. 
    It will also add a charge per oligo. You will not receive QC traces with your order, 
    please contact us before placing the order if you would like to receive the traces.
    Please refer the order confirmation`
  },
  tooltip: {
    id: 'tooltip',
    defaultMessage: `Plate order cutoff time is 2pm EST for orders wth complete information 
    (i.e. billing and shipping information, etc.). Orders received after 2pm may be processed 
    the next business day.`
  }
});

export default { ...generalMessages, ...messages };
